import * as React from "react";
import TextField from "@mui/material/TextField";
import { useState, useEffect } from "react";
import { store } from "../../redux/store";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { useLazyGetUsersQuery } from "../../redux/slices/userApi";
import { useDispatch, useSelector } from "react-redux";

const UserWidget = (props) => {
  const { t } = useTranslation();
  const defaultProp = props?.schema?.default;
  const err = props?.rawErrors?.[0];
  const update = props?.schema?.update;
  const [firstRender, setFirstRender] = useState(true);
  const users = useSelector((state) => state?.userSlice?.users);
  const mappedUsers = users?.map((user) => ({
    label: `${user?.attributes?.first_name} ${user?.attributes?.last_name}`,
    id: user?.attributes?.id,
  }));

  const [getUsers] = store.useLazyGetUsersQuery();
  const [value, setValue] = useState();
  useEffect(() => {
    if (!users) {
      getUsers();
    }
  }, []);
  const defaultValue = mappedUsers?.filter(
    (item) => item.id == defaultProp
  )?.[0];
  useEffect(() => {
    if (value) {
      props.onChange(value.id ?? defaultValue.id);
    } else {
      props.onChange(update ? defaultValue?.id : "");
    }
  }, [value, defaultValue]);

  useEffect(() => {
    console.log("chekdefval", defaultValue);
  }, [defaultValue]);
  useEffect(() => {
    console.log("pisyapopasda", props);
  }, [props]);

  return (
    <>
      {mappedUsers && !update && (
        <Autocomplete
          fullWidth
          disablePortal
          value={value}
          id="combo-box-demo"
          options={mappedUsers ?? []}
          onChange={(event, newInputValue) => {
            setValue(newInputValue);
          }}
          defaultValue={defaultValue}
          renderInput={(params) => (
            <TextField error={err} {...params} label={t("user")} />
          )}
        />
      )}
      {mappedUsers && defaultValue && update && (
        <Autocomplete
          fullWidth
          disablePortal
          value={value}
          id="combo-box-demo"
          options={mappedUsers ?? []}
          onChange={(event, newInputValue) => {
            setValue(newInputValue);
          }}
          defaultValue={defaultValue}
          renderInput={(params) => (
            <TextField error={err} {...params} label={t("user")} />
          )}
        />
      )}
      {!mappedUsers && (
        <Autocomplete
          fullWidth
          disablePortal
          disabled
          id="combo-box-demo"
          options={[]}
          renderInput={(params) => <TextField {...params} label={t("user")} />}
        />
      )}
    </>
  );
};
export default UserWidget;
